import { useTotpStatus, useResetTotp } from "../api/totp";
import "./totp-status-panel.css";

interface TotpStatusPanelProps {
    userId: string;
    userName: string;
    onClose: () => void;
}

export const TotpStatusPanel = ({
    userId,
    userName,
    onClose,
}: TotpStatusPanelProps): JSX.Element => {
    const { data: totpStatus, isLoading } = useTotpStatus(userId);
    const resetMutation = useResetTotp();

    const handleReset = async () => {
        if (
            !confirm(
                "Är du säker på att du vill återställa TOTP? Användaren måste sätta upp ny TOTP för att kunna logga in."
            )
        ) {
            return;
        }

        try {
            await resetMutation.mutateAsync(userId);
            alert("TOTP har återställts. Användaren måste sätta upp ny TOTP.");
            onClose();
        } catch (error: any) {
            const message = error?.response?.data?.message || "Ett fel uppstod";
            alert(`Kunde inte återställa TOTP: ${message}`);
        }
    };

    return (
        <div className="totp-status-overlay" onClick={onClose}>
            <div className="totp-status-panel" onClick={(e) => e.stopPropagation()}>
                <div className="totp-status-panel__header">
                    <h3>TOTP Status för {userName}</h3>
                    <button
                        className="totp-status-panel__close-button"
                        onClick={onClose}
                        aria-label="Stäng"
                    >
                        ×
                    </button>
                </div>

                <div className="totp-status-panel__content">
                    {isLoading ? (
                        <p>Laddar...</p>
                    ) : totpStatus ? (
                        <>
                            <div className="totp-status-panel__status">
                                <div className="status-item">
                                    <strong>Status:</strong>
                                    <span
                                        className={`status-badge ${totpStatus.isEnabled ? "status-badge--enabled" : "status-badge--disabled"}`}
                                    >
                                        {totpStatus.isEnabled ? "✅ Aktiverat" : "❌ Inaktiverat"}
                                    </span>
                                </div>
                                {totpStatus.hasSecret && !totpStatus.isEnabled && (
                                    <div className="status-item">
                                        <strong>Setup-status:</strong>
                                        <span className="status-badge status-badge--warning">
                                            ⚠️ Secret finns men inte aktiverat
                                        </span>
                                    </div>
                                )}
                            </div>

                            {totpStatus.isEnabled && (
                                <div className="totp-status-panel__warning">
                                    <p>
                                        <strong>Varning:</strong> Om du återställer TOTP kommer användaren inte kunna
                                        logga in tills de har satt upp en ny TOTP.
                                    </p>
                                </div>
                            )}

                            <div className="totp-status-panel__actions">
                                <button
                                    className="totp-status-panel__reset-button"
                                    onClick={handleReset}
                                    disabled={resetMutation.isPending}
                                >
                                    {resetMutation.isPending ? "Återställer..." : "Återställ TOTP"}
                                </button>
                            </div>
                        </>
                    ) : (
                        <p>Kunde inte ladda TOTP-status.</p>
                    )}
                </div>

                <div className="totp-status-panel__footer">
                    <button
                        type="button"
                        className="totp-status-panel__close-footer-button"
                        onClick={onClose}
                    >
                        Stäng
                    </button>
                </div>
            </div>
        </div>
    );
};